@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              <mat-icon
                *ngIf="column.key.view"
                class="btn-icon-outline"
                fontIcon="visibility"
                matTooltip="Visualizar"
                (click)="viewItemEvent(element)"
              />
            </div>
          } @else if (column.keyColumn == 'tg_info') {
            <b>Tg: </b>{{ element.codigoTg }}<br />
            <b>Evento: </b>{{ element.nomeEvento ?? '-' }}
          } @else if (column.keyColumn == 'client_info') {
            <b>Cliente: </b>{{ element.nomeCliente }}<br />
            <b>SubCliente: </b>{{ element.nomeSubCliente ?? '-' }}
          } @else if (column.keyColumn == 'event_period') {
            <b>Inicio:</b> {{ element.dataInicio }}<br />
            <b>Fim:</b> {{ element.dataFinal }}
          } @else if (column.keyColumn == 'os_pendentes') {
            @if (element.osPendentes > 0) {
              {{ element.osPendentes }} pendente(s)
            } @else {
              Concluído
            }
          } @else {
            {{ element[column.key] }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}
